import React from "react";
import { Link, NavLink } from "react-router-dom";
import { useSelector } from "react-redux";

const Navbar = () => {
  const likesCount = Object.keys(useSelector((s) => s.likes.items)).length;
  const wishlistCount = Object.keys(useSelector((s) => s.wishlist.items)).length;
  const watchlistCount = Object.values(useSelector((s) => s.watchlist.items)).filter(
    (i) => i.status !== "watched"
  ).length;

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark sticky-top">
      <div className="container">
        <Link className="navbar-brand brand-text" to="/">
          <i className="fas fa-film mr-2"></i>SceneIt
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#mainNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="mainNav">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item">
              <NavLink className="nav-link" exact to="/">
                <i className="fas fa-search mr-1"></i> Search
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/likes">
                <i className="fas fa-heart"></i>
                {likesCount > 0 && <span className="badge badge-danger ml-1">{likesCount}</span>}
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/wishlist">
                <i className="fas fa-bookmark"></i>
                {wishlistCount > 0 && <span className="badge badge-warning ml-1">{wishlistCount}</span>}
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link" to="/watchlist">
                <i className="fas fa-calendar-alt"></i>
                {watchlistCount > 0 && <span className="badge badge-info ml-1">{watchlistCount}</span>}
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
